export enum UserRoleEnum {
  SUPERVISOR = 'supervisor',
  FULL = 'full',
  BASIC = 'basic',
  SALESMAN = 'salesman',
  ADMIN = 'admin',
  SPECIAL_USER = 'special_user',
}
